import {useSelector} from 'react-redux';
import {useMemo} from 'react';

export const useCompanyBankingCreationDate = () => {
  const companyDetails = useSelector(state => state.banking?.companyDetails);

  return useMemo(() => companyDetails?.wallet_created_at, [companyDetails?.wallet_created_at]);
};